import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { FiHome } from 'react-icons/fi';
import IconWrapper from '../components/print-steps/IconWrapper';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      
      <main className="flex-grow flex items-center p-4 sm:p-6 md:p-12"> 
        <div className="container mx-auto py-4 sm:py-8"> 
          <div className="flex flex-col md:flex-row items-center md:space-y-0 space-y-8 sm:space-y-12"> 
            {/* Left column - Text content */}
            <div className="md:w-1/2 md:pr-12 mb-8 sm:mb-12 md:mb-0"> 
              <div className="relative mb-8 sm:mb-12">
                <span className="text-6xl sm:text-7xl md:text-8xl font-black text-blue-600 opacity-90 relative z-10 
                     drop-shadow-[0_2px_2px_rgba(0,0,0,0.3)]">404</span>
                <span className="absolute text-6xl sm:text-7xl md:text-8xl font-black text-blue-500 opacity-20 
                     -top-1 -left-1 z-0">404</span>
              </div>
              
              <h1 className="text-5xl sm:text-6xl md:text-6xl lg:text-6xl font-bold text-gray-800 mb-8 sm:mb-10 md:mb-12"> 
                Sorry, we couldn't find that page
              </h1>
              
              <p className="text-lg sm:text-xl md:text-xl text-gray-800 mb-10 sm:mb-14 md:mb-16 font-medium leading-relaxed border-l-4 pl-4 border-blue-400 py-2"> 
              Looks like this document got jammed in the printer! Try going back to the homepage.
              </p>
              
              <div className="mt-2 sm:mt-4"> 
                <Button 
                  onClick={() => navigate('/')}
                  className="bg-blue-600 hover:bg-blue-700 text-white py-3 sm:py-4 px-6 sm:px-10 rounded-md text-base sm:text-lg flex items-center"
                >
                  <IconWrapper icon={FiHome} className="mr-2 sm:mr-3 h-4 w-4 sm:h-5 sm:w-5" /> 
                  Go to homepage
                </Button>
              </div>
            </div>
            
            {/* Right column - Printer animation */}
            <div className="md:w-1/2 flex justify-center">
              <div className="relative w-80 h-80">

                <div className="absolute top-10 right-4 w-24 h-32 bg-white shadow-md rounded-sm transform rotate-6 z-10"></div>
                <div className="absolute top-16 right-12 w-20 h-28 bg-white shadow-md rounded-sm transform -rotate-3 z-20"></div>
                

                <div className="w-64 h-40 bg-gray-800 rounded-lg shadow-xl relative top-24 left-8 border-t border-gray-700 z-30">
                  <div className="w-full h-6 bg-gray-700 absolute top-0 rounded-t-lg"></div>
                  <div className="w-48 h-1 bg-black absolute top-12 left-0 right-0 mx-auto"></div>
                  

                  <div className="absolute w-8 h-8 rounded-full bg-blue-500 opacity-20 blur-xl -right-4 -top-4"></div>
                  

                  <div className="absolute right-4 top-2 w-3 h-3 rounded-full bg-blue-400 shadow-sm"></div>
                  
                  <div className="absolute bottom-4 left-4 w-16 h-3 rounded bg-gray-600"></div>
                  <div className="absolute bottom-10 left-4 w-12 h-3 rounded bg-gray-600"></div>
                  
                  <div className="w-40 h-20 bg-white absolute -top-16 left-12 rounded-sm shadow-lg transform -rotate-12 z-40 border border-gray-200">
                    <div className="w-24 h-1 bg-gray-300 mb-2 mt-6 ml-6"></div>
                    <div className="w-20 h-1 bg-gray-300 mb-2 ml-6"></div>
                    <div className="w-28 h-1 bg-gray-300 ml-6"></div>
                    <div className="absolute top-2 right-4 text-3xl font-black text-red-500 transform -rotate-12">404</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;
